import gql from "graphql-tag";

export const LIST_TICKET = gql`
  query MyQuery(
    $order_by: [events_list_view_order_by!] = {
      customer: asc
      payment: asc
      purchase: asc
      redeem: asc
      ticket_number: asc
      total: asc
      type: asc
    }
    $search: String = ""
    $id: uuid = ""
  ) {
    events_list_view(
      order_by: $order_by
      where: {
        customer: { _ilike: $search }
        event_id: { _eq: $id }
        is_going: { _eq: true }
      }
    ) {
      customer
      event_id
      payment
      purchase
      redeem
      ticket_number
      total
      type
    }
    events_list_view_aggregate(
      order_by: $order_by
      where: { customer: { _ilike: $search }, event_id: { _eq: $id } }
    ) {
      aggregate {
        count(columns: id)
      }
    }
  }
`;
